export default {
  path: '/cargos/:id',
  component: () => import('@/components/pages/Roles/Role.vue')
}
